import { PiLifebuoyDuotone } from "react-icons/pi";

export default function PlatformSupportBanner({ user, merchant }) {
  if (!user?.support_mode) return null;
  return (
    <div data-testid="support-mode-banner"
      className="bg-amber-500 text-black px-4 py-2 flex items-center gap-2 font-mono text-[11px] tracking-widest uppercase">
      <PiLifebuoyDuotone className="text-base" />
      Platform Support Mode — {merchant?.name || user?.merchant_name} • granted to {user.support_by} • all actions audited
    </div>
  );
}
